<template>
    <div class="" style="position: relative;">
        <v-text-field
            v-model="selectedModel.name"
            :disabled="modelCantBeRenamed"
            :label="$t('instance.data_model.form_editor.fields_form.create_model_input_label')"
            @blur="checkForSuggestion"
        ></v-text-field>

        <name-suggestion ref="name-suggestion" @suggestion-accepted="selectedModel.name=$event"></name-suggestion>
        <v-textarea
            counter
            :label="$t('instance.data_model.form_editor.fields_form.model_description')"
            :rules="formActive?rules:[]"
            v-model="selectedModel.model_description"
        ></v-textarea>
        <v-checkbox
            v-model="selectedModel.is_default_public"
            :disabled="readOnly"
            :label="$t('instance.data_model.form_editor.fields_form.checkbox_label')"
        ></v-checkbox>


        <v-btn
            class="btn-duplicate-model"
            color="primary"
            @click="dupplicateModel"
        >
            {{$t('instance.data_model.form_editor.fields_form.duplicate_model')}}
        </v-btn>
        <v-container fluid style="padding: 0;">
            <label
                aria-hidden="true"
                class="v-label v-label--active theme--dark"
            >
                {{$t('instance.data_model.form_editor.fields_form.propreties')}}
            </label>
            <v-row>
                <v-col cols="12" lg="4">
                    <div
                        v-for="(value, key, index) in selectedModel.fields "
                        :key="index"
                        class="property-field">
                        <v-text-field
                            v-model="value.name"
                            :error-messages="value.name === fieldWithError ? fieldErrorMessage : ''"
                            :placeholder="$t('instance.data_model.form_editor.fields_form.placeholder_name')"
                            :disabled="fieldIsDisabled(value.name)"
                            readonly
                            @focus="selectProperty(value, key)"
                        >
                        </v-text-field>
                        <v-icon
                            v-if="canDeleteProperty(value, selectedModel)"
                            small
                            right
                            @click="onDeletedProperty(value)"
                        >delete</v-icon>
                    </div>
                    <v-btn
                        v-if="!readOnly"
                        color="info"
                        :disabled="fieldHasError"
                        style="margin-left: 0"
                        @click="addProperty"
                    >
                        {{$t('instance.data_model.form_editor.fields_form.btn_property')}}
                    </v-btn>
                    <v-tooltip bottom color="error" :disabled="!cantDeleteModel">
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn
                                    v-if="!readOnly"
                                    style="margin-left: 0"
                                    :disabled="cantDeleteModel"
                                    @click="onDeleteSelectedModel()"
                                    color="error"
                                    class="delete-btn"
                                >
                                    {{$t('instance.data_model.form_editor.fields_form.btn_delete_model')}}
                                </v-btn>
                            </div>
                        </template>
                        <span>{{$t('instance.data_model.form_editor.fields_form.cant_delete_descr', {modelName: selectedModel.name})}}</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" lg="8">
                    <form-property
                        ref="formProperty"
                        v-if="selectedPropertie"
                        :margin="propertyIndex * 64"
                        :property="selectedPropertie"
                        :schema="schema"
                        :currentModel="selectedModel"
                        :read-only="readOnly"
                        @abort-property-edition="onPropertyEditionAborted"
                        @updateErrorField="updateErrorField"
                    ></form-property>
                </v-col>
            </v-row>
        </v-container>

        <dialog-confirm
            ref="dialog-delete-model"
            :callback-confirm="deleteSelectedModel"
            :text-confirm="$t('instance.data_model.form_editor.fields_form.dialog_text_confirm_delete')"
        >
        </dialog-confirm>
        <dialog-confirm
            ref="modal-delete-field"
            :text="$t('instance.data_model.form_editor.propertie_form.confirm_text')"
            :title="$t('instance.data_model.form_editor.propertie_form.confirm_title')"
            :callback-confirm="deleteProperty"
            :text-confirm="$t('instance.data_model.form_editor.propertie_form.confirm_delete_text')"
            :text-decline="$t('instance.data_model.form_editor.propertie_form.decline_text')"
        ></dialog-confirm>
        <dialog-notify
            ref="dialog-success-delete-model"
            :title="$t('instance.data_model.form_editor.fields_form.dialog_title_delete')"
        >
        </dialog-notify>
        <dialog-notify
            ref="dialog-error-delete-model"
            :title="$t('instance.data_model.form_editor.fields_form.dialog_title_delete_error')"
        >
        </dialog-notify>
    </div>
</template>

<script>
import FormProperty from './propertie-form.vue';
import DialogConfirm from '@/components/Partials/dialog-confirm.vue';
import DialogNotify from '@/components/Partials/dialog-notify.vue';
import NameSuggestion from '../name-suggestion.vue';
import rulesMixins from '@/components/Mixins/rulesMixins.vue';

export default {
    mixins: [rulesMixins],

    components: {
        FormProperty,
        DialogConfirm,
        DialogNotify,
        NameSuggestion,
    },

    props: {
        selectedModel: {
            type: Object,
            required: true,
        },
        schema: {
            type: Object,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
    },

    data (){
        return {
            modelName: '',
            selectedPropertie: null,
            selectedPropertieName: '',
            propertyIndex: 0,
            fieldWithError: '',
            readonlyGroupFields: ['name', 'members'],
            readonlyUserFields: ['email'],
            model_description: '',
            rules: [
                v => (v && v.length <= 50) || this.$t('instance.data_model.form_editor.fields_form.model_description_rules')
            ],
            selectedPropertyToDelete: null,
        };
    },

    computed: {
        fieldHasError (){
            return this.fieldWithError !== '';
        },
        fieldErrorMessage (){
            return this.$t('instance.data_model.form_editor.fields_form.fieldErrorMessage');
        },
        invalidNameCase (){
            return this.$helpers.invalidNameCase(this.selectedModel.name);
        },
        modelCantBeRenamed (){
            if(this.readonly) return true;
            if(this.selectedModel.name === 'Group' ||this.selectedModel.name === 'User') return true;
            return false;
        },
        cantDeleteModel(){
            return  ['group', 'user'].includes(this.selectedModel.name.toLowerCase());
        },
    },

    watch: {
        'selectedModel.name' (){
            this.$store.dispatch('updateEditorSaveBtnIfDataModelEdited', this.schema);
        },
    },

    mounted (){
    },

    methods: {
        onDeletedProperty(value){
            this.selectedPropertyToDelete = value;
            this.$refs['modal-delete-field'].open();
        },
        deleteProperty (){
            this.$emit('abort-property-edition');
            this.schema.deleteField(this.selectedPropertyToDelete);
            this.$store.dispatch('updateEditorSaveBtnIfDataModelEdited', this.schema);
            this.$eventBus.$emit('save-schema');
        },
        addProperty (){
            let index = this.selectedModel.addField();
            this.selectProperty({name: ''}, index);
            if (this.selectedModel.fields.length > 6) {
                this.propertyIndex = this.selectedModel.fields.length - 6;
            }
        },

        selectProperty (property, index){
            if(this.fieldIsDisabled(property.name)) return;
            // 6 = nombre de field equivalent à la hauteur de la carte d'édition
            // si on dépasse 6, on fait glisser la carte de `x - 6` cran(s) pour la carte reste à côté du champ édité
            // un cran = 64px
            if (index > 6) {
                this.propertyIndex = index - 6;
            }
            else {
                this.propertyIndex = 0;
            }
            this.selectedPropertieName = property.name;
            this.$set(this, 'selectedPropertie', this.selectedModel.fields.find(prop => prop.name === property.name));
            if (this.$refs.formProperty) {
                this.$refs.formProperty.$refs.nameField.focus();
            }
        },

        updateErrorField (fieldName, hasError=true){
            if(hasError){
                this.fieldWithError = fieldName;
            }else{
                this.fieldWithError = '';
            }
        },
        fieldIsDisabled (propertyName){
            if(this.selectedModel.name === 'Group' ){
                if(this.readonlyGroupFields.includes(propertyName)){
                    return true;
                }
            }else if(this.selectedModel.name === 'User'){
                if(this.readonlyUserFields.includes(propertyName)){
                    return true;
                }
            }
            return false;
        },
        onDeleteSelectedModel (){
            this.$refs['dialog-delete-model'].open(
                this.$t('instance.data_model.form_editor.fields_form.onDeleteSelectedModel_message', {model : this.schema.selectedModel.name}),
                this.$t('instance.data_model.form_editor.fields_form.onDeleteSelectedModel_message_confirm', {model : this.schema.selectedModel.name})
           );
        },
        deleteSelectedModel (){
            let pluralize = this.$helpers.pluralize;
            this.schema.deleteCurrentModel().then((modelName) => {
                this.$eventBus.$emit('save-schema');
                let message = this.$t('instance.data_model.form_editor.fields_form.deleteSelectedModel_message', {modelName : modelName});
                this.$refs['dialog-success-delete-model'].open(message);
            }).catch((e) => {
                if(typeof e === 'string'){
                    // si l'erreur est un string c'est que le model que l'on souhaite supprimer est un model scoppeur
                    let message = this.$t('instance.data_model.form_editor.fields_form.deleteSelectedModel_message_catch', {selectedModel : this.schema.selectedModel.name});
                    this.$refs['dialog-error-delete-model'].open(message);
                }else{
                    // sinon cela signifie que certains models ont une relations avec ce model
                    let relatedModels = e.map((item) => item.name);
                    // let message = `You can't delete the model <strong>${this.schema.selectedModel.name}</strong> because model${pluralize(relatedModels.length)} <strong>${e.map((item) => item.name).join(', ')}</strong> ${pluralize(relatedModels.length, 'be')} related to it. Please delete relation field${pluralize(relatedModels.length)} and try again.`;


                    let message = this.$t('instance.data_model.form_editor.fields_form.deleteSelectedModel_message_catch_else',
                        {
                            selectedModel : this.schema.selectedModel.name,
                            relatedModels : relatedModels.join(', '),
                            isPlural: pluralize(relatedModels.length),
                            isVerbPlural: pluralize(relatedModels.length, this.$t('instance.data_model.form_editor.fields_form.verb'))
                        }
                    );
                    this.$refs['dialog-error-delete-model'].open(message);
                }
            });
        },
        canDeleteProperty(prop, model){
            if(model.name.toLowerCase() === 'group'){
                if(prop.name === 'members' || prop.name === 'name'){
                    return false;
                }
            }
            if(model.name.toLowerCase() === 'user' && prop.name === 'email'){
                return false;
            }
            return true;
        },
        checkForSuggestion (){
            if(this.invalidNameCase){
                this.$refs['name-suggestion'].open(this.invalidNameCase, {left: '0', top: '50px'});
            }
        },
        onPropertyEditionAborted(){
            this.selectedPropertie = null;
            this.fieldWithError = '';
        },
        dupplicateModel(){
            let modelToDuplicate = JSON.parse(JSON.stringify(this.selectedModel));
            this.$eventBus.$emit('on-choose-duplicate-model-name', modelToDuplicate);
        }
    },
};
</script>

<style lang="scss">
.btn-save-model-name{
    position: absolute;
    top: -20px;
    right: 0px;
}
.property-field{
    display: flex;
    align-items: center;
}
.btn-duplicate-model{
    margin-bottom: 2em;
}

.delete-btn{
    margin-top: 15px;
    width: 243px;
    padding-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/fields-form.vue